import Vue from 'vue'
import {SPLIT_ON_ALL_BUT_NON_SPACING_MARKS_REGEX} from 'shared/js/commonHebrew'

export function getStandardLetterArray(chosenWordString) {
  return chosenWordString.split(SPLIT_ON_ALL_BUT_NON_SPACING_MARKS_REGEX)
}

export function getChosenWordString(wordObj) {
  return wordObj.choiceType === 'option' ? wordObj.options[wordObj.chosenOptionIndex].displayText
          : (wordObj.choiceType === 'manual' ? wordObj.manualNikud : wordObj.editedNikud)
}

export function assignChosenStringAndLetterArray (wordObj) {
  Vue.set(wordObj, 'chosenWordString', getChosenWordString(wordObj))
  // console.log("wordObj['chosenWordString']:")
  // console.log(wordObj['chosenWordString'])
  Vue.set(wordObj, 'standardLetterArray', getStandardLetterArray(wordObj.chosenWordString))
}
